import type { FlightConfig } from "@b2bportal/core-flights";

export const flightsAppConfig: FlightConfig = {
  showCalendarPriceRangeTags: false,
};
